/* WP4x4 Year/Make/Model vehicle picker. No dependencies.
   Adapted from Crew Cab Collective's ccc-ymm.js (C3 Bot): same flow (cascading selects -> vehicle collection
   with the Search & Discovery vehicle filter, saved vehicle in localStorage with Clear, product fit note),
   reworked for generation-based Jeep/Bronco fitment.
   Data (snippets/wp-ymm-data.liquid): {g:{JL:{n,v,c,t[]}}, r:[[make,model,from,to,gen]], c:[{l,h,g[],o{gen:handle}}]} */
(function () {
  'use strict';
  if (window.__wpYmm) return;
  window.__wpYmm = true;

  var KEY = 'wp_vehicle_v1';
  var PARAM = 'filter.p.m.custom.filter_options';
  var D = null;

  function data() {
    if (D) return D;
    var el = document.querySelector('[data-wp-ymm-data]');
    try { D = JSON.parse(el.textContent); } catch (e) { D = null; }
    return D;
  }
  function getSaved() {
    try { var t = JSON.parse(localStorage.getItem(KEY) || 'null'); return t && t.y && t.mk && t.md && t.g ? t : null; } catch (e) { return null; }
  }
  function setSaved(t) {
    try { t ? localStorage.setItem(KEY, JSON.stringify(t)) : localStorage.removeItem(KEY); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wp:vehicle', { detail: t }));
  }
  function uniq(a) { var o = {}, out = []; a.forEach(function (x) { if (!o[x]) { o[x] = 1; out.push(x); } }); return out; }
  function gensFor(d, y, mk, md) {
    return uniq(d.r.filter(function (r) { return (!mk || r[0] === mk) && (!md || r[1] === md) && (!y || (+y >= r[2] && +y <= r[3])); }).map(function (r) { return r[4]; }));
  }
  function valid(d, t) { return !!(t && d.g[t.g] && gensFor(d, t.y, t.mk, t.md).indexOf(t.g) !== -1); }
  function name(d, t) { return t.y + ' ' + d.g[t.g].n; }
  function cat(d, h) { for (var i = 0; i < d.c.length; i++) if (d.c[i].h === h) return d.c[i]; return null; }
  function vehicleHandles(d) { return Object.keys(d.g).map(function (k) { return d.g[k].c; }); }

  function buildUrl(root, d, t, catHandle) {
    var g = d.g[t.g], colRoot = root.dataset.colRoot, filt = PARAM + '=' + encodeURIComponent(g.v).replace(/%20/g, '+');
    var c = catHandle ? cat(d, catHandle) : null;
    if (c) {
      if (c.o && c.o[t.g]) return colRoot + c.o[t.g];               // existing vehicle-specific category collection
      return colRoot + c.h + '?' + filt;                             // category filtered to the generation
    }
    var here = root.dataset.colHandle;
    if (root.dataset.ctx === 'collection' && here && root.dataset.colFilterable === 'true' && vehicleHandles(d).indexOf(here) === -1) {
      var keep = [];                                                 // stay in this department, add the vehicle filter
      new URLSearchParams(location.search).forEach(function (v, k) { if (k !== PARAM && k !== 'page') keep.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
      keep.push(filt);
      return root.dataset.colUrl + '?' + keep.join('&');
    }
    return colRoot + g.c;                                            // the generation's own vehicle collection
  }

  function fill(sel, items, placeholder, value) {
    sel.innerHTML = '';
    var o = document.createElement('option'); o.value = ''; o.textContent = placeholder; sel.appendChild(o);
    items.forEach(function (it) {
      var op = document.createElement('option'); op.value = it[0]; op.textContent = it[1];
      if (String(it[0]) === String(value)) op.selected = true;
      sel.appendChild(op);
    });
    sel.disabled = items.length === 0;
    if (value && sel.value !== String(value)) sel.value = '';
  }

  function productTags(root) {
    var el = root.querySelector('[data-ymm-product]');
    if (!el) return null;
    var tags; try { tags = JSON.parse(el.textContent); } catch (e) { return null; }
    var out = {};
    (tags || []).forEach(function (tg) { String(tg).split(/[\/,\s]+/).forEach(function (p) { p = p.trim().toUpperCase(); if (p) out[p] = 1; }); });
    return out;
  }


  /* ---------- Strict YMM (Nov 1 2026) ----------
     With a saved vehicle every listing shows only fitting parts. The inline early script
     (snippets/wp-ymm-strict-early.liquid) already redirected to the vehicle-filtered view where it could and left
     window.__wpYmmS.mode: own | filtered (Search & Discovery did the filtering) | universal (nothing here is
     vehicle-specific) | hide (hide non-fitting cards here) | nofit (nothing here fits) | none (no vehicle).
     Cards carry data-ymm-v (vehicle tags), data-ymm-w/-bp (wheels, bolt pattern) and data-ymm-8 (8x6.5 wheels),
     from snippets/wp-ymm-fit.liquid. Untagged non-wheel parts count as universal and stay visible. */
  var JEEP = { JL: 1, JK: 1, JT: 1, TJ: 1 };
  var BP = { JL: ['5x5', '5x127'], JK: ['5x5', '5x127'], JT: ['5x5', '5x127'], TJ: ['5x4.5', '5x114.3'], BR: ['6x5.5', '6x139.7'] };
  var NOTE8 = '8x6.5 bolt pattern: requires one-ton axles (not a fit on stock Jeep axles)';
  function SX() { return window.__wpYmmS || { mode: 'none' }; }
  function is8(s) { return /8\s*x\s*(6\.5|165)/i.test(s || ''); }
  function vtoks(s) { return (s || '').split(/\s+/).filter(Boolean); }
  // fit: 1 fits, 0 does not, 'u' universal (no vehicle tags, not a wheel). one-ton flag when it fits only via 8x6.5
  function fitOf(d, gk, v, w, bp, b8) {
    var g = d.g[gk];
    if (v.length) return g.t.some(function (x) { return v.indexOf(x) !== -1; }) ? 1 : 0;
    if (!w) return 'u';
    var pats = vtoks(bp).reduce(function (a, b) { return a.concat(b.split('/')); }, []);
    if (pats.some(function (p) { return BP[gk].indexOf(p) !== -1; })) return 1;
    if (JEEP[gk] && (b8 || pats.some(is8))) return 1;
    return 0;
  }
  function jeepCtx(d) {
    var s = SX();
    if (s.t) return !!JEEP[s.t.g];
    var c = s.ctx || {}, gk = null;
    for (var k in d.g) if (d.g[k].c === c.h) gk = k;
    if (!gk) d.c.forEach(function (ct) { for (var k in (ct.o || {})) if (ct.o[k] === c.h) gk = k; });
    if (!gk) new URLSearchParams(location.search).getAll(PARAM).forEach(function (v) { for (var k in d.g) if (d.g[k].v === v) gk = k; });
    if (gk && JEEP[gk]) { try { sessionStorage.setItem('wp_ymm_jctx', '1'); } catch (e) {} }
    return !!(gk && JEEP[gk]);
  }
  function cardBox(el) {
    return el.closest('[data-armada-animation="grid-item"]') || el.closest('li[data-name="slide"]') || el.closest('li') || el;
  }
  var hiddenCount = 0;
  function processCard(d, el, jc) {
    if (el.__wpYmm) return; el.__wpYmm = 1;
    var s = SX(), t = s.t;
    var v = vtoks(el.getAttribute('data-ymm-v')), w = el.hasAttribute('data-ymm-w'), bp = el.getAttribute('data-ymm-bp') || '', b8 = el.getAttribute('data-ymm-8') || '';
    if (t && s.mode !== 'none' && s.mode !== 'redirect') {
      // own/filtered pages: Search & Discovery already filtered; still hide cards whose vehicle tags say another vehicle
      var trust = (s.mode === 'own' || s.mode === 'filtered') && el.closest('main') && !v.length;
      var f = fitOf(d, t.g, v, w, bp, b8);
      if (s.mode === 'nofit' && el.closest('main')) f = 0;
      if (!trust && f === 0) { cardBox(el).classList.add('wp-ymm-hide'); hiddenCount++; return; }
    }
    if (b8 && jc && !el.querySelector('.wp-ymm-8')) {
      var bdg = document.createElement('span');
      bdg.className = 'wp-ymm-8'; bdg.title = NOTE8;
      bdg.textContent = b8 === 'some' ? '8x6.5 sizes: one-ton axles required' : '8x6.5: one-ton axles required';
      var anchor = el.querySelector('[data-name="price"]') || el.querySelector('[data-name="title"]');
      if (anchor) anchor.parentNode.insertBefore(bdg, anchor.nextSibling); else el.appendChild(bdg);
    }
  }
  function scanCards(d) {
    var jc = jeepCtx(d);
    document.querySelectorAll('[data-ymm]').forEach(function (el) { processCard(d, el, jc); });
  }
  function statusMsg(d) {
    var s = SX(), t = s.t, el = document.querySelector('[data-ymm-status]');
    var mainEl = document.querySelector('main');
    if (el && mainEl && el.closest('.wp-ymm') && !mainEl.contains(el)) {   // keep the sticky strip slim: show the message at the top of the page content
      var wrap = document.createElement('div'); wrap.className = 'wp-ymm-statuswrap'; wrap.appendChild(el); mainEl.insertBefore(wrap, mainEl.firstChild);
    }
    if (!el || !t) return;
    var nm = name(d, t), g = d.g[t.g], root = (s.ctx && s.ctx.root) || '/collections/';
    el.className = 'wp-ymm__status'; el.innerHTML = '';
    function txt(x) { el.appendChild(document.createTextNode(x)); }
    function link(href, x) { var a = document.createElement('a'); a.href = href; a.textContent = x; el.appendChild(a); }
    var main = document.querySelector('main') || document.body;
    var listing = s.ctx && (s.ctx.t === 'collection' || s.ctx.t === 'search');
    if (s.mode === 'own' || s.mode === 'filtered') { txt('\u2713 Showing only parts that fit your ' + nm + '.'); }
    else if (s.mode === 'universal') { el.classList.add('wp-ymm__status--info'); txt('These parts aren\u2019t vehicle-specific, so everything here is shown. Check sizes and fitment notes for your ' + nm + '.'); }
    else if (s.mode === 'hide' && listing) {
      var cards = main.querySelectorAll('[data-ymm]'), vis = 0;
      cards.forEach(function (c) { if (!cardBox(c).classList.contains('wp-ymm-hide')) vis++; });
      if (cards.length && !vis) { el.classList.add('wp-ymm__status--warn'); txt('Nothing on this page is listed for your ' + nm + '. '); link(root + g.c, 'See all ' + g.n + ' parts'); }
      else if (!hiddenCount && ![].some.call(cards, function (c) { return (c.getAttribute('data-ymm-v') || '').trim() || c.hasAttribute('data-ymm-w'); })) {
        el.classList.add('wp-ymm__status--info'); txt('These parts aren\u2019t vehicle-specific, so everything here is shown. Check sizes and fitment notes for your ' + nm + '.');
      } else { txt('\u2713 Showing only parts that fit your ' + nm + (hiddenCount ? ' (' + hiddenCount + ' that don\u2019t fit are hidden)' : '') + '.'); }
    } else if (s.mode === 'nofit') {
      el.classList.add('wp-ymm__status--warn');
      txt(s.other ? 'This page lists ' + d.g[s.other].n + ' parts. You\u2019re shopping for a ' + nm + '. ' : 'No parts here are listed for your ' + nm + ' yet. ');
      link(root + g.c, 'See all ' + g.n + ' parts');
      nofitBox(d, t, main, root);
    } else { el.hidden = true; return; }
    el.hidden = false;
  }
  function nofitBox(d, t, main, root) {
    if (document.querySelector('.wp-ymm-nofit-box')) return;
    document.documentElement.classList.add('wp-ymm-nofit');
    var g = d.g[t.g], s = SX(), box = document.createElement('div');
    box.className = 'wp-ymm-nofit-box'; box.setAttribute('role', 'status');
    var st = document.createElement('strong');
    st.textContent = s.other ? 'These are ' + d.g[s.other].n + ' parts' : 'No parts here fit your ' + name(d, t);
    box.appendChild(st);
    box.appendChild(document.createTextNode((s.other ? 'You\u2019re shopping for a ' + name(d, t) + ', so we\u2019re not showing them. ' : 'We only show parts listed for your vehicle. ')));
    var p = document.createElement('p'); p.style.margin = '10px 0 0';
    var a = document.createElement('a'); a.href = root + g.c; a.textContent = 'See all ' + g.n + ' parts'; p.appendChild(a);
    var b = document.createElement('button'); b.type = 'button'; b.textContent = 'Change vehicle';
    b.addEventListener('click', function () { var c = document.querySelector('[data-ymm-change]'); if (c) { c.click(); window.scrollTo(0, 0); } });
    p.appendChild(b);
    var cl = document.createElement('button'); cl.type = 'button'; cl.textContent = 'Clear vehicle and show everything';
    cl.addEventListener('click', function () { var c = document.querySelector('[data-ymm-clear]'); if (c) c.click(); });
    p.appendChild(cl);
    box.appendChild(p);
    var grid = main.querySelector('[data-armada-selector="collection-card-grid"]') || main.querySelector('[data-ymm]');
    var host = grid ? (grid.closest('section') || grid.parentNode) : main;
    host.parentNode ? host.parentNode.insertBefore(box, host) : main.prepend(box);
  }
  // product page: one-ton note next to the price, follows the selected variant
  function currentVariant() {
    var m = location.search.match(/[?&]variant=(\d+)/);
    var sel = document.querySelector('main form[action*="/cart/add"] select[name="id"], main form[action*="/cart/add"] input[name="id"]:not([disabled])');
    return (sel && sel.value) || (m && m[1]) || '';
  }
  function pfit() { var el = document.querySelector('[data-ymm-pfit]'); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function variantIs8(pf) {
    if (!pf || !pf.b8) return false;
    if (pf.b8 === 'all') return true;
    var id = currentVariant();
    return !!id && pf.v8.map(String).indexOf(String(id)) !== -1;
  }
  function productNote8(d) {
    var pf = pfit(); if (!pf || !pf.b8) return;
    var s = SX(), show;
    if (s.t) show = !!JEEP[s.t.g];
    else { var j = false; try { j = sessionStorage.getItem('wp_ymm_jctx') === '1'; } catch (e) {} show = j || vtoks(pf.v).some(function (x) { return x !== 'BRONCO'; }); }
    var note = document.querySelector('[data-ymm-8note]');
    if (!note) {
      var price = document.querySelector('main [data-name="price"][data-product-form-block]') || document.querySelector('main product-price');
      if (!price) return;
      note = document.createElement('p'); note.className = 'wp-ymm-8note'; note.setAttribute('data-ymm-8note', ''); note.setAttribute('role', 'note');
      note.textContent = '\u26a0 ' + NOTE8;
      price.parentNode.insertBefore(note, price.nextSibling);
    }
    note.hidden = !(show && variantIs8(pf));
  }
  var strictStarted = false;
  function startStrict(d) {
    if (strictStarted) return; strictStarted = true;
    scanCards(d); statusMsg(d); productNote8(d);
    var pend = false;
    new MutationObserver(function () {
      if (pend) return; pend = true;
      setTimeout(function () { pend = false; scanCards(d); if (SX().mode === 'hide') statusMsg(d); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
    var lastV = currentVariant();
    function vchk() { var v = currentVariant(); if (v !== lastV) { lastV = v; productNote8(d); document.dispatchEvent(new CustomEvent('wp:variant')); } }
    document.addEventListener('change', function () { setTimeout(vchk, 30); }, true);
    document.addEventListener('click', function () { setTimeout(vchk, 120); }, true);
    window.addEventListener('popstate', vchk);
    setInterval(vchk, 700);
  }

  function init(root) {
    var d = data();
    var S = { y: root.querySelector('[data-ymm-year]'), mk: root.querySelector('[data-ymm-make]'), md: root.querySelector('[data-ymm-model]'),
              g: root.querySelector('[data-ymm-gen]'), cat: root.querySelector('[data-ymm-cat]') };
    var genField = root.querySelector('[data-ymm-gen-field]');
    var form = root.querySelector('[data-ymm-form]'), go = root.querySelector('[data-ymm-go]'), msg = root.querySelector('[data-ymm-msg]');
    var clearBtn = root.querySelector('[data-ymm-clear]'), summary = root.querySelector('[data-ymm-summary]');
    var sumLink = root.querySelector('[data-ymm-sum-link]'), changeBtn = root.querySelector('[data-ymm-change]');
    var fitEl = root.querySelector('[data-ymm-fit]'), openBtn = root.querySelector('[data-ymm-open]');
    if (!d) { msg.textContent = 'Vehicle search is unavailable right now. Use the menu to shop by vehicle.'; return; }
    var allGen = Object.keys(d.g);
    var years = uniq(d.r.reduce(function (a, r) { for (var y = r[3]; y >= r[2]; y--) a.push(y); return a; }, [])).sort(function (a, b) { return b - a; });

    function cur() { return { y: S.y.value, mk: S.mk.value, md: S.md.value, g: S.g.value }; }

    function cascade(want) {
      var y = want ? String(want.y) : S.y.value;
      fill(S.y, years.map(function (v) { return [v, v]; }), 'Year', y);
      y = S.y.value;
      var makes = uniq(d.r.filter(function (r) { return y && +y >= r[2] && +y <= r[3]; }).map(function (r) { return r[0]; }));
      fill(S.mk, makes.map(function (m) { return [m, m]; }), 'Make', want ? want.mk : S.mk.value);
      var mk = S.mk.value;
      var models = uniq(d.r.filter(function (r) { return mk && r[0] === mk && +y >= r[2] && +y <= r[3]; }).map(function (r) { return r[1]; }));
      fill(S.md, models.map(function (m) { return [m, m]; }), 'Model', want ? want.md : S.md.value);
      var md = S.md.value;
      var gens = md ? gensFor(d, y, mk, md) : [];
      // 2018 Wrangler: JK was carried over that year, so ask which one
      fill(S.g, gens.map(function (g) { return [g, g === 'JL' ? 'JL (new body)' : g === 'JK' ? 'JK (carryover)' : g]; }), 'JL or JK?', want ? want.g : (gens.length === 1 ? gens[0] : S.g.value));
      if (gens.length === 1) S.g.value = gens[0];
      genField.hidden = gens.length < 2;
      var g = S.g.value;
      var cats = g ? d.c.filter(function (c) { return c.g.indexOf(g) !== -1; }) : [];
      fill(S.cat, cats.map(function (c) { return [c.h, c.l]; }), 'Part type (optional)', S.cat.value);
      S.cat.disabled = !g;
      go.disabled = !valid(d, cur());
      msg.textContent = '';
    }

    // Nov 2 2026: also fills the buy-box fit badge (snippets/wp-buybox-extras.liquid, [data-wp-fitbadge]).
    function fitBadge(cls, text) {
      var b = document.querySelector('[data-wp-fitbadge]');
      if (!b || b.closest('[data-universal]')) return;
      b.className = 'wp-fitbox__badge' + (cls ? ' is-' + cls : '');
      b.textContent = '';
      if (cls) {
        var ic = document.createElement('span'); ic.className = 'wp-fitbox__ic'; ic.setAttribute('aria-hidden', 'true');
        ic.textContent = cls === 'yes' ? '\u2713' : (cls === 'no' ? '\u2717' : '\u26a0');
        b.appendChild(ic); b.appendChild(document.createTextNode(' ' + text));
        if (cls !== 'yes') { b.appendChild(document.createTextNode(' ')); var ch = document.createElement('button'); ch.type = 'button'; ch.className = 'wp-fitbox__pick'; ch.setAttribute('data-wp-fit-pick', ''); ch.textContent = 'Change vehicle'; b.appendChild(ch); }
      } else {
        var pk = document.createElement('button'); pk.type = 'button'; pk.className = 'wp-fitbox__pick'; pk.setAttribute('data-wp-fit-pick', ''); pk.textContent = text; b.appendChild(pk);
      }
    }
    function selBP() {
      var ins = document.querySelectorAll('main input[type=radio]:checked, main select option:checked'), m;
      for (var i = 0; i < ins.length; i++) { m = /(?:^|[^\d.])([4-8])\s*x\s*(\d+(?:\.\d+)?)/i.exec(ins[i].value || ins[i].textContent || ''); if (m) return m[1] + 'x' + m[2]; }
      return '';
    }
    function productFit(t) {
      if (fitEl) { fitEl.hidden = true; fitEl.className = 'wp-ymm__fit'; }
      if (!t || !valid(d, t)) { fitBadge('', 'Check fit: select your vehicle'); return; }
      var pf = pfit(), tags = productTags(root);
      if (!pf && !tags) return;
      var v = pf ? vtoks(pf.v) : Object.keys(tags || {}).filter(function (x) { return /^(JL|JK|JT|TJ|LJ|BRONCO)$/.test(x); });
      var w = pf ? pf.w : false, on8 = variantIs8(pf);
      var f = fitOf(d, t.g, v, w, pf ? pf.bp : '', on8 ? 'all' : '');
      if (f === 'u') return;                                         // universal / no vehicle tags: header says nothing, badge shows "Universal fit"
      var txt, cls;
      if (f && on8 && JEEP[t.g]) {
        txt = 'Your ' + name(d, t) + ' needs one-ton axles for this 8x6.5 wheel'; cls = 'warn';
        if (fitEl) { fitEl.textContent = '\u26a0 ' + txt; fitEl.classList.add('wp-ymm__fit--warn'); }
      } else if (f && w && selBP() && BP[t.g] && BP[t.g].indexOf(selBP()) === -1 && !is8(selBP())) {
        txt = 'This option is ' + selBP() + ' \u2013 your ' + name(d, t) + ' needs ' + BP[t.g][0] + '. Pick a ' + BP[t.g][0] + ' option'; cls = 'warn';
        if (fitEl) { fitEl.textContent = '\u26a0 ' + txt; fitEl.classList.add('wp-ymm__fit--warn'); }
      } else if (f) {
        txt = (v.length ? 'Fits your ' : 'Bolt pattern matches your ') + name(d, t); cls = 'yes';
        if (fitEl) { fitEl.textContent = '\u2713 ' + txt; fitEl.classList.add('wp-ymm__fit--yes'); }
      } else {
        txt = 'Doesn\u2019t fit your ' + name(d, t); cls = 'no';
        if (fitEl) { fitEl.textContent = 'Not listed for your ' + name(d, t) + ' \u2013 check the fitment details'; fitEl.classList.add('wp-ymm__fit--no'); }
      }
      if (fitEl) fitEl.hidden = false;
      fitBadge(cls, txt);
    }
    document.addEventListener('wp:variant', function () { productFit(getSaved()); });
    document.addEventListener('change', function (e) { var x = e.target; if (x && x.closest && x.closest('main') && x.matches('input[type=radio], select') && document.querySelector('[data-wp-fitbadge]')) setTimeout(function () { productFit(getSaved()); }, 0); });
    window.addEventListener('load', function () { setTimeout(function () { if (document.querySelector('[data-wp-fitbadge]')) productFit(getSaved()); }, 300); });

    function emptyNotice(t) {
      if (root.dataset.ctx !== 'collection' || root.dataset.colCount !== '0') return;
      if (!new URLSearchParams(location.search).has(PARAM) || !t || !valid(d, t)) return;
      msg.innerHTML = '';
      msg.appendChild(document.createTextNode('Nothing here is listed for your ' + name(d, t) + ' yet. '));
      var a = document.createElement('a'); a.href = root.dataset.colRoot + d.g[t.g].c; a.textContent = 'See all ' + d.g[t.g].n + ' parts';
      msg.appendChild(a);
      root.classList.add('is-editing');
    }

    function showSummary(t) {
      if (t && valid(d, t)) {
        root.classList.add('is-saved');
        summary.hidden = false;
        sumLink.textContent = name(d, t);
        sumLink.href = root.dataset.colRoot + d.g[t.g].c;
        clearBtn.hidden = false;
      } else {
        root.classList.remove('is-saved', 'is-editing');
        summary.hidden = true;
        clearBtn.hidden = true;
      }
      changeBtn.setAttribute('aria-expanded', root.classList.contains('is-editing') ? 'true' : 'false');
      productFit(t);
    }

    [S.y, S.mk, S.md, S.g].forEach(function (s) { s.addEventListener('change', function () { cascade(); }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = cur();
      if (!valid(d, t)) { msg.textContent = genField.hidden ? 'Pick a year, make and model.' : 'Pick JL or JK for a 2018 Wrangler.'; return; }
      setSaved(t);
      location.href = buildUrl(root, d, t, S.cat.value);
    });
    changeBtn.addEventListener('click', function () {
      var on = root.classList.toggle('is-editing');
      changeBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) S.y.focus();
    });
    openBtn.addEventListener('click', function () {
      var on = root.classList.toggle('is-editing');
      openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) S.y.focus();
    });
    var sumClear = root.querySelector('[data-ymm-sum-clear]');
    if (sumClear) sumClear.addEventListener('click', function () { clearBtn.click(); });
    clearBtn.addEventListener('click', function () {
      var hadStrict = SX().t && SX().mode !== 'none';
      setSaved(null);
      if (hadStrict) {                                               // show everything again
        var u = new URL(location.href), g = d.g[SX().t.g];
        if (u.searchParams.getAll(PARAM).indexOf(g.v) !== -1) { u.searchParams.delete(PARAM); u.searchParams.delete('page'); location.replace(u.href); }
        else location.reload();
        return;
      }
      S.y.value = ''; cascade();
      showSummary(null);
      root.classList.add('is-editing');
      S.y.focus();
    });
    document.addEventListener('wp:vehicle', function (e) { var t = e.detail; if (t && valid(d, t)) cascade(t); showSummary(t); });

    var t = getSaved();
    if (t && !valid(d, t)) t = null;
    cascade(t || undefined);
    showSummary(t);
    root.removeAttribute('aria-busy');
  }

  function start() { document.querySelectorAll('[data-wp-ymm]').forEach(init); var d = data(); if (d) startStrict(d); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
